export const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:7002";
const X_API_KEY = process.env.REACT_APP_X_API_KEY || "";

// Mutable auth state
let authToken = "";
let token = null;
let secret = null;
let activeProfile = null;

export const setAuth = (jwt, tokenVal, secretVal) => {
  authToken = jwt || "";
  token = tokenVal || null;
  secret = secretVal || null;
};

export const setActiveProfile = (profile) => {
  activeProfile = profile || null;
};

export const getActiveProfile = () => activeProfile;

export const getToken = () => token;

export const getSecret = () => secret;

export const clearAuth = () => {
  authToken = "";
  token = null;
  secret = null;
  activeProfile = null;
  localStorage.removeItem("formStudioEmail");
  localStorage.removeItem("formStudioToken");
};

const buildHeaders = () => {
  const headers = {
    "Content-Type": "application/json",
  };

  if (X_API_KEY) {
    headers["x-api-key"] = X_API_KEY;
  }

  if (authToken) {
    headers["Authorization"] = `Bearer ${authToken}`;
  }

  if (activeProfile?.id) {
    headers["X-Sub-Identity"] = activeProfile.id;
  } else {
    headers["X-Sub-Identity"] = 'none';
  }

  return headers;
};

const handleResponse = async (response) => {
  if (!response.ok) {
    let errorMessage = `${response.status} ${response.statusText}`;
    let correlationId = null;
    try {
      const body = await response.json();
      if (body.message) errorMessage = Array.isArray(body.message) ? body.message.join(" ") : body.message;
      if (body.error) errorMessage = body.error;
      if (body.correlationId) correlationId = body.correlationId;
    } catch {
      // Response body wasn't JSON — use status text
    }
    const err = new Error(errorMessage);
    err.correlationId = correlationId;
    throw err;
  }

  if (response.status === 204) return null;

  const text = await response.text();
  return text ? JSON.parse(text) : null;
};

export const get = async (path) => {
  const response = await fetch(`${BASE_URL}${path}`, {
    method: "GET",
    headers: buildHeaders(),
  });
  return handleResponse(response);
};

export const post = async (path, body) => {
  const response = await fetch(`${BASE_URL}${path}`, {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(body),
  });
  return handleResponse(response);
};

export const put = async (path, body) => {
  const response = await fetch(`${BASE_URL}${path}`, {
    method: "PUT",
    headers: buildHeaders(),
    body: JSON.stringify(body),
  });
  return handleResponse(response);
};

export const patch = async (path, body) => {
  const response = await fetch(`${BASE_URL}${path}`, {
    method: "PATCH",
    headers: buildHeaders(),
    body: JSON.stringify(body),
  });
  return handleResponse(response);
};

export const del = async (path) => {
  const response = await fetch(`${BASE_URL}${path}`, {
    method: "DELETE",
    headers: buildHeaders(),
  });
  if (!response.ok) {
    let errorMessage = `${response.status} ${response.statusText}`;
    let correlationId = null;
    try {
      const body = await response.json();
      if (body.message) errorMessage = Array.isArray(body.message) ? body.message.join(" ") : body.message;
      if (body.error) errorMessage = body.error;
      if (body.correlationId) correlationId = body.correlationId;
    } catch {
      // Response body wasn't JSON
    }
    const err = new Error(errorMessage);
    err.correlationId = correlationId;
    throw err;
  }
};

export default {
  get,
  post,
  put,
  patch,
  del,
  setAuth,
  setActiveProfile,
  getActiveProfile,
  getToken,
  getSecret,
  clearAuth,
};
